import { createEffect, createEvent, createStore } from 'effector';
import { errorHandlerFx } from '../../../model/errorHandler';
import { createEffectJWT } from '../../../model/JWT';
import { dynamicObjectExportTaskGetList } from '../../../apiRPC/dynamicObjectExportTask';

export type DynamicObjectExportAccessState = boolean | null;

export const resetDynamicObjectExportAccess = createEvent();

export const $dynamicObjectExportAccess = createStore<DynamicObjectExportAccessState>(null).reset(
  resetDynamicObjectExportAccess,
);

const rawCheckDynamicObjectExportAccessFx = createEffectJWT(async () => {
  try {
    await dynamicObjectExportTaskGetList({
      filter: {
        limit: 1,
        offset: 0,
      },
    });

    return true;
  } catch (error: unknown) {
    const anyError = error as { code?: number } | null;

    if (anyError && typeof anyError.code === 'number' && anyError.code === 190) {
      return false;
    }

    throw error;
  }
});

export const checkDynamicObjectExportAccessFx = errorHandlerFx(
  rawCheckDynamicObjectExportAccessFx,
);

$dynamicObjectExportAccess.on(checkDynamicObjectExportAccessFx.doneData, (_, hasAccess) => hasAccess);

